'use client';

import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from '@/shared/ui/checkbox';
import '@/shared/ui/checkbox/checkbox.scss';
import { FormFieldMessage } from './form-field-message';
import { FormFieldProps } from './types';
import { getFormFieldState } from './utils/getFormFieldState';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof Checkbox> & {
    label?: ReactNode;
};
export const FormCheckbox = ({
    id,
    name,
    control,
    label,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    messageWrapperProps,
    isErrorVisible = true,
    isSuccessVisible,
    ref,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({
                field: { ref: fieldRef, value, onChange, ...field },
                fieldState: { error, isDirty, isTouched, invalid },
            }) => {
                const state = getFormFieldState({
                    invalid,
                    isDirty,
                    isTouched,
                    isErrorVisible,
                    isSuccessVisible,
                });

                return (
                    <>
                        <div className="checkbox__wrapper">
                            <Checkbox
                                ref={mergeRefs([fieldRef, ref])}
                                id={id || name}
                                state={state}
                                checked={value}
                                onCheckedChange={onChange}
                                {...parseRulesForInputAttributes(rules)}
                                {...field}
                                {...props}
                            />
                            {label && <label htmlFor={id || name}>{label}</label>}
                        </div>
                        <FormFieldMessage
                            state={state}
                            error={error}
                            messageWrapperProps={messageWrapperProps}
                        />
                    </>
                );
            }}
        />
    );
};
